var React = require('react');

function PalletAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M560 64H400a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zM304 0H80a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M624 384a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h48v64H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h608a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-48v-64zm-336 64H128v-64h160zm224 0H352v-64h160z","className":"fa-primary","key":2})]);
}

PalletAlt.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = PalletAlt;

PalletAlt.default = PalletAlt;
